
import { DateTime } from 'luxon'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import Dokument from '@/components/models/Dokument.vue'
import InviterTilbudsgiver from '@/components/InviterTilbudsgiver.vue'
import * as DKFDS from 'dkfds'
import { v4 as uuid } from 'uuid'
import { DocumentStatus } from '@/components/Const'
import axios from '@/services/axios-instance'
import { formatDate } from '@/components/util/DateTime'
import KlarTekst from '@/components/KlarTekst.vue'
import { Action, Getter } from 'vuex-class'
import ToastUtil from '@/ToastUtil'

@Options({
  components: {
    Dokument,
    InviterTilbudsgiver,
    KlarTekst
  },
  data () {
    return {
      DocumentStatus
    }
  }
})
export default class DokumentVisning extends Vue {
  emitter = require('tiny-emitter/instance')
  @Getter('getContentfulTcoModel') contentfulTcoModel
  @Action('addToast') addToast
  randomIdentifier : string = uuid()

  @Prop({ type: Dokument })
  dokument

  mounted () : void {
    // initialize accordion
    DKFDS.init() // NOSONAR
  }

  label () : string {
    return 'accordion-' + this.randomIdentifier
  }

  getActionsBoxHeight (value : string) : string {
    if (value === DocumentStatus.PUBLISHED) {
      return 'min-height: 298px'
    } else if (value === DocumentStatus.DRAFT) {
      return 'min-height: 228px'
    } else if (value === DocumentStatus.CLOSED) {
      return 'min-height: 164px'
    } else {
      return ''
    }
  }

  IsNotOverdue (value : string) : boolean {
    if (!value) return true
    var deadline = Date.parse(value)
    var now = Date.parse(DateTime.now().toString())
    if (deadline > now) {
      return true
    }
    return false
  }

  doAction (url : string, id : string) : void {
    axios.post(process.env.VUE_APP_DIRIGENT_URL + url + id, '',
      {
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
      this.emitter.emit('reloadDocuments')
    }).catch(error => this.addToast(ToastUtil.createToastForErrorResponse(error, this.contentfulTcoModel)))
  }

  closeTender (id : string) : void {
    this.doAction('/web/form/afslutUdbud/', id)
  }

  publish (id : string) : void {
    this.doAction('/web/form/publicerUdbud/', id)
  }

  deleteDraft (id : string) : void {
    this.doAction('/web/form/sletKladde/', id)
  }

  date (value : string) : string | undefined {
    return formatDate(value)
  }

  printOpsummering (blanketId: string) : void {
    const route = this.$router.resolve({ path: '/blanketprint/' + blanketId })
    window.open(route.href, '_blank')
  }
}
